import { Outlet, createFileRoute, redirect } from '@tanstack/react-router';
import { api, ApiError } from '../lib/api';
import { useAuthStore } from '../lib/auth-store';
import { Shell } from '../components/Shell';

export const Route = createFileRoute('/_authed')({
  beforeLoad: async () => {
    try {
      const me = await api.me();
      useAuthStore.getState().setUser(me);
    } catch (err) {
      if (err instanceof ApiError && err.status === 401) {
        throw redirect({ to: '/login' });
      }
      throw err;
    }
  },
  component: AuthedLayout,
});

function AuthedLayout() {
  return (
    <Shell>
      <Outlet />
    </Shell>
  );
}
